import { SentryService } from '@ianesthesie-kit/sentry';

/**
 * Reports a PDF report viewer/printer failure to Sentry with diagnostic tags.
 *
 * Kept free of `react-pdf` / `pdfjs-dist` imports so it stays cheap to import
 * from eagerly-loaded components (e.g. the print button) without pulling pdf.js
 * into their bundle.
 */
export const capturePdfReportError = (
  error: unknown,
  path: 'view' | 'print'
): void => {
  SentryService.getInstance().captureException(error, {
    tags: { feature: 'pdf-report', path }
  });
};
